import "../reaction-list/reaction-list.scss";
import api from "api";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router";
import { ReactionListType, ReactionListRequestType } from "types";
import { toast } from "react-toastify";

function CrisisMonitoring() {
  const params: any = useParams();
  const history = useHistory();
  const [reactionList, setReactionList] = useState<ReactionListType | null>(null);
  const [editable, setEditable] = useState(false);
  const [showAddKeywordModal, setShowAddKeywordModal] = useState(false);
  const [keywordValue, setKeywordValue] = useState("");
  const [keywordType, setKeywordType] = useState("");

  const onIntervalChange = (id: string) => {
    console.log(id);
    setReactionList({
      ...reactionList!,
      NotificationInterval: id,
    });
  };

  const onUpdate = useCallback(() => {
    let reactionListRequest: ReactionListRequestType | undefined;
    reactionListRequest!.Id = reactionList!.Id;
    reactionListRequest!.ClientId = 0; // TODO
    reactionListRequest!.ProjectId = reactionList!.ProjectId;
    reactionListRequest!.Description = reactionList!.Description;
    reactionListRequest!.NotificationInterval = Number(reactionList? reactionList.NotificationInterval : 0);
    reactionListRequest!.WordBinTypeId = 2;
    reactionListRequest!.LanguageId = "en";
    reactionListRequest!.StartDate = reactionList!.StartDate;
    reactionListRequest!.StopDate = reactionList!.StopDate;
    reactionListRequest!.IsGeneric = reactionList!.IsGeneric;
    reactionListRequest!.Recipients = reactionList!.Recipients;
    reactionListRequest!.Keywords = reactionList!.Keywords;
    reactionListRequest!.AccountId = 0; //TODO

    api.reactionLists.update(reactionListRequest!).then((data) => {
      // if (data.success) {
      //     toast.success("Wordbin Updated")
      // }
      // else {
      //     toast.error("Error occurred updating wordbin")
      // }
    });
  }, [params.reactionListId]);

  const onDelete = useCallback(() => {
    api.reactionLists.delete(reactionList!.Id).then((data) => {
      if (data.success) {
        toast.success("Worbin deleted");
      } else {
        toast.error("Error occured deleting Wordbin");
      }
    });
  }, [params.reactionListId]);

  const handleAddKeywordModal = (show: boolean) => {
    setShowAddKeywordModal(show);
  };

  const handleAddKeyword = () => {};

  const onGetReactionList = useCallback(() => {
    api.reactionLists.get(params.reactionListId).then((data) => {
      setReactionList(data);
    });
  }, [params.reactionListId]);

  const handleWordBinRecipientTypeId = useCallback((id: number) => {
    switch (id) {
      case 1:
        return "Alert Contact";
      case 2:
        return "Popup Contact";
      case 3:
        return "Response Contact";
      default:
        return null;
    }
  }, []);

  const handleOperatorId = useCallback((id: number) => {
    switch (id) {
      case 1:
        return "AND";
      case 2:
        return "OR";
      case 3:
        return "NOT";
      default:
        return null;
    }
  }, []);

  useEffect(() => {
    onGetReactionList();
  }, [onGetReactionList]);

  return (
    <>
      <div className="body">
        <div className="left">
          <h5>Reaction List</h5>
          {/* <button id="btn-view-logs" onClick={() => { }}>View Logs</button>
                    <button id="btn-view-workflow" onClick={() => { }}>View Workflow</button> */}
          <p className="heading">Details & Recipients</p>
          <div className="left">
            <p className="heading">Name</p>
            <input id="name" disabled={!editable} value={reactionList?.Description}></input>
          </div>

          <div className="right">
            <p className="heading">Notify Me</p>
            <select onChange={(e) => onIntervalChange(e.currentTarget.value)} value={reactionList?.NotificationInterval} id="notify" disabled={!editable}>
              <option value="0">Immediate</option>
              <option value="5">Every 5 minutes</option>
              <option value="10">Every 10 minutes</option>
              <option value="20">Every 20 minutes</option>
              <option value="30">Every 30 minutes</option>
              <option value="60">Every Hour</option>
              <option value="360">Every Six Hours</option>
              <option value="720">Every Twelve Hours</option>
              <option value="1440">Once a day</option>
            </select>
          </div>

          {/* <div className="right">
                        <p className="heading">Language</p>
                        <p id="language">{reactionList?.LanguageId}</p>
                    </div> */}

          <div className="left">
            <p className="heading">Sentiment</p>
            <select defaultValue="0" value={reactionList?.SentimentId} id="sentiment" disabled={!editable}>
              <option value="0">None</option>
              <option value="1">Neutral</option>
              <option value="2">Positive</option>
              <option value="3">Negative</option>
            </select>
          </div>
          <br />
          <div className="left" id="div-start-date">
            <p className="heading">Start Date</p>
            <input disabled={!editable} type="date" id="start-date" value={moment(reactionList?.StartDate).format("YYYY-MM-DD")}></input>
          </div>

          <div className="right" id="div-end-date">
            <p className="heading">End Date</p>
            <input disabled={!editable} type="date" id="end-date" value={moment(reactionList?.StopDate).format("YYYY-MM-DD")}></input>
          </div>

          <div id="div-recipients">
            <p className="heading">Recipients</p>
            <div id="recipients">
              {!reactionList?.Recipients.length ? (
                <i style={{ display: "block", textAlign: "center", width: "100%" }}>No recipients added</i>
              ) : (
                reactionList?.Recipients.map((x) => (
                  <div className="recipient" data-id={x.ContactId} data-type-id={x.WordBinRecipientTypeId}>
                    <p className="type">{handleWordBinRecipientTypeId(x.WordBinRecipientTypeId)}</p>
                    <p className="value">{x.Name + " " + x.Surname + " (" + x.Email + ")"}</p>
                    {editable ? <i className="fal fa-times"></i> : <></>}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <div className="right">
          <p className="heading">Keywords</p>
          <div id="keywords">
            {!reactionList?.Keywords.length ? (
              <i style={{ display: "block", textAlign: "center", width: "100%" }}>No keywords added</i>
            ) : (
              reactionList?.Keywords.map((x) => (
                <div className="keyword">
                  <p className="type" data-id={x.OperatorId}>
                    {handleOperatorId(x.OperatorId)}
                  </p>
                  <p className="value">{x.Value}</p>
                  {editable ? <i className="fal fa-times"></i> : <></>}
                </div>
              ))
            )}
          </div>

          {editable && !showAddKeywordModal ? (
            <button id="btn-add-keyword" onClick={() => handleAddKeywordModal(true)}>
              Add Keyword
            </button>
          ) : (
            <></>
          )}

          {showAddKeywordModal ? (
            <div className="input-group" id="add-keyword-div">
              <div className="left">
                <p className="heading">Keyword</p>
                <input onChange={(e) => setKeywordValue(e.currentTarget.value)} type="text" id="keyword" placeholder="Keyword" />
              </div>
              <div className="right">
                <p className="heading">Keyword Type</p>
                <select onChange={(e) => setKeywordType(e.currentTarget.value)} id="keyword-type">
                  <option value="1">AND</option>
                  <option value="2">OR</option>
                  <option value="3">NOT</option>
                </select>
              </div>

              <div className="button-group">
                <button onClick={() => setShowAddKeywordModal(false)}>Cancel</button>
                <button onClick={handleAddKeyword}>Save</button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="foot">
        {!editable ? (
          <></>
        ) : (
          <button
            id="btn-cancel-word-bin"
            onClick={() => {
              setEditable(false);
              setShowAddKeywordModal(false);
            }}
          >
            Cancel
          </button>
        )}
        <button id="btn-delete-word-bin" onClick={onDelete}>
          Delete
        </button>
        {!editable ? (
          <button id="btn-save-word-bin" onClick={() => setEditable(true)}>
            <i className="fal fa-pencil"></i> Edit
          </button>
        ) : (
          <button id="btn-save-word-bin" onClick={onUpdate}>
            <i className="fal fa-save"></i> Save
          </button>
        )}
      </div>
    </>
  );
}

export default CrisisMonitoring;
